import { helper } from '@ember/component/helper';
import { TransferStep } from '@square/dashboard-protos/models/squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step';
function getRowStyles([rowStyle]) {
  switch (rowStyle) {
    case TransferStep.TransferConfirmation.RowItem.DescriptionStyle.BOLD:
      return 'bold';
    case TransferStep.TransferConfirmation.RowItem.DescriptionStyle.REGULAR:
    default:
      return 'regular';
  }
}
export default helper(getRowStyles);